
import { Sale } from "@/models/base";
import { SaleService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			amount: 0.0,
			sending: false
		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async confirm(){
			if (this.sending) return;
			this.sending = true;
			try{
				await SaleService.addDeposit(this.sale.ID, this.amount);
				let message = this.$ct("deposit-crated");
				this.$wf.notify(message, "success", 3000, "check");
				this.$emit("refresh");
				this.$emit("close");
			}catch(err){
				this.sending = false;
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
